import { defineComponent } from 'vue'
import { useAuthStore } from '@/store/auth/auth'

export default defineComponent({
  name: 'StartScreenLayout',
  setup() {
    const authStore = useAuthStore()

    return { authStore }
  },
})
